export const NO_SCORE = "none";
export const MANUAL_SCORE = "manual";
export const AUTOMATIC_SCORE = "auto";
export const RUBRIC_SCORE = "rubric";
export const AUTOSCORE_TYPES = [AUTOMATIC_SCORE, RUBRIC_SCORE];
